import { InputWrapper } from "./input-wrapper";
import { Error } from "./error";
import type { FormErrors } from "@repo/shared-types";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: { value: string; label: string }[];
  errors?: FormErrors;
}

export function Select({
  label,
  options,
  className = "",
  errors,
  ...props
}: SelectProps) {
  const showError = errors?.[props.name ?? ""];
  return (
    <div className="flex flex-col gap-1">
      <InputWrapper label={label}>
        <select
          key={props.name}
          className={`w-full outline-none ${className}`}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </InputWrapper>
      {showError && <Error fieldName={props.name} errors={errors} />}
    </div>
  );
}
